import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { OwnerUserService } from '../../../../../../services/owner-user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Helpers } from '../../../../../../helpers';
import { BaseComponent } from '../../../base.component';
import { OwnerUser } from '../../../../../../models/owner-user';

@Component({
    selector: 'app-users',
    templateUrl: './update-user.component.html',
    encapsulation: ViewEncapsulation.None
})
export class UpdateUserComponent extends BaseComponent implements OnInit {
    user: OwnerUser = new OwnerUser();

    userid: string;

    constructor(
        private usersService: OwnerUserService,
        private router: Router,
        route: ActivatedRoute
    ) {
        super();
        this.user.id = route.snapshot.params['id'];
    }

    ngOnInit() {
        this.getUser();
    }

    getUser() {
        Helpers.setLoading(true);
        this.usersService.find(this.user.id).subscribe(res => {
            Helpers.setLoading(false);
            this.user = res.data;
            this.user.password = '';
        });
    }

    validate(event) {
        var customRules = this.validationService.customRules;
        return this.validationService.validate(event, {
            rules: {
                firstName: customRules.requiredText,
                lastName: customRules.requiredText,
                email: customRules.requiredEmail
            }
        });
    }

    updateUser() {
        Helpers.setLoading(true);
        var _self = this;
        this.usersService.update(this.user).subscribe(() => {
            Helpers.setLoading(false);
            this.swalService.successUpdate();
            setTimeout(function() {
                _self.router.navigate(['/owner/users/list']);
            }, 1000);
        });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/owner/owner-user/update-user/update-user.component.ts